var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import Toggle from "react-toggle";
var EntitlementPreferenceControl = function (_a) {
    var preference = _a.preference, preferenceChoices = _a.preferenceChoices, onPreferenceChange = _a.onPreferenceChange;
    var handlePreferenceChange = function (e) {
        var preferenceIdChanged = e.target.value;
        var isPreferenceDisabled = preference.disabledPreferences.includes(preferenceIdChanged);
        var updatedPreferences;
        if (isPreferenceDisabled) {
            updatedPreferences = preference.disabledPreferences.filter(function (disabledPreferenceId) { return disabledPreferenceId !== preferenceIdChanged; });
        }
        else {
            updatedPreferences = __spreadArray(__spreadArray([], preference.disabledPreferences, true), [preferenceIdChanged], false);
        }
        onPreferenceChange(preference.id, updatedPreferences);
    };
    return (React.createElement("div", { className: "entitlement-preference-control-container" },
        React.createElement("div", { className: "logo-title-container" },
            React.createElement("span", { className: "site-logo", "data-site-path": preference.imageDataSlug }),
            React.createElement("h3", { className: "entitlement-preference-label" }, "publicName" in preference ? preference.publicName : preference.id)),
        React.createElement("div", { className: "preference-indent" }, preferenceChoices.map(function (preferenceChoice, index) { return (React.createElement("div", { key: index },
            React.createElement("label", { key: index, className: "toggle-label" },
                React.createElement("span", null, preferenceChoice.id),
                React.createElement(Toggle, { defaultChecked: !preference.disabledPreferences.includes(preferenceChoice.id), onChange: handlePreferenceChange, disabled: preferenceChoice.disabled, value: preferenceChoice.id, icons: false })),
            React.createElement("hr", null))); }))));
};
export default EntitlementPreferenceControl;
